import { Navigate, useLocation } from "react-router-dom";
import { useAuthenticator } from "@aws-amplify/ui-react";

export function ProtectedRoute({ children }: { children: JSX.Element }) {
  const { pathname, search } = useLocation();
  const { authStatus } = useAuthenticator((context) => [context.authStatus]);

  return authStatus === "authenticated" ? (
    children
  ) : (
    <Navigate to={`/?redirect=${pathname}${search}`} replace />
  );
}
